import { Injectable } from '@angular/core';
import {ConfigurationDataService} from '../configuration-data.service';
import {SharedDataService} from '../shared-data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {Area} from './area';

@Injectable()
export class AreaService {

  headers = new HttpHeaders({
      'Content-Type': 'application/json'
  });

  constructor(public http: HttpClient, private config : ConfigurationDataService, private shared: SharedDataService) {
  }

  /**
   * List all areas which belong to loggedin user.
   */
  public list() {
    console.log(JSON.stringify(this.shared.getTokenAuthData()));
    return this.http.post(this.config.areaURL+"list", JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public save(area : Area) {
    console.log('Push area to insert method of service.');
    area.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(area));
    return this.http.post(this.config.areaURL+"new", JSON.stringify(area), {headers: this.headers});
  }

  public update(area : Area) {
    console.log('Push area to update method of service.');
    area.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(area));
    return this.http.put(this.config.areaURL+"id/"+area.id, JSON.stringify(area), {headers: this.headers});
  }

  public qryArea(id : number) {
    return this.http.post(this.config.areaURL+"id/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public delete(id : number) {
    console.log('Delete area '+ id);
    return this.http.post(this.config.areaURL+"del/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/location/area.service.ts